import type { IncomingMessage, ServerResponse } from 'node:http';

import type { JsonSerializer } from '#introspection.js';

import { omit } from 'lodash-es';
import pinoStdSerializers from 'pino-std-serializers';

export const knownSerializers = {
  date: (v: Date) => v.toISOString(),
  url: (v: URL | string) => v.toString(),
  symbol: (v: symbol) => v.toString(),
  bigint: (v: bigint) => v.toString(),
  function: (v: Function) => v.toString(),
  regexp: (v: RegExp | string) => v.toString(),
  errorWithCause: pinoStdSerializers.errWithCause,
  error: pinoStdSerializers.err,
  request: (v: IncomingMessage) => omit(pinoStdSerializers.req(v), ['raw']),
  response: (v: ServerResponse) => omit(pinoStdSerializers.res(v), ['raw']),
} satisfies { [key: string]: JsonSerializer<any> } & { zod?: JsonSerializer<any> };

export function registerSerializer<T>(name: string, serializer: JsonSerializer<T>): void {
  (knownSerializers as Record<string, any>)[name] = serializer;
}
